import { DAILY_PROMPT_FALLBACK } from "./constants";
import { tabFromPath } from "./routing";
import type { AppState } from "./types";

export const state: AppState = {
  loadingAuth: true,
  loadingPage: false,
  profileResolved: false,
  guestMode: true,
  user: null,
  profile: null,
  notificationPrefs: null,
  authMode: "signin",
  activeTab: tabFromPath(window.location.pathname),
  feedFilter: "all",
  feedFilterUserSet: false,
  feedInitialLoadDone: false,
  feedPosts: [],
  recentlyPublishedPosts: [],
  resonatedPostIds: new Set(),
  savedPostIds: new Set(),
  resonanceCountOverrides: {},
  hiddenFeedPostIds: [],
  publicThoughtPool: [],
  discoveryDirections: [],
  discoveryRankedIds: [],
  discoveryTagsByPostId: {},
  discoveryShelfPostIds: null,
  sharedThoughtNotice: null,
  portrait: {
    available: false, availabilityResolved: false, enabled: false, consentResolved: false,
    unreviewedOptIn: false, loading: false, loadFailed: false, enabling: false,
    claims: [], presentation: { clusters: [], needsYourWordIds: [], display: {}, carryQuestion: null, portraitText: null },
    decidedIds: new Set(), deferredIds: new Set(), lastDecidedId: null,
    selectedTheme: null, focusedNodeId: null, selectedClaimId: null,
    claimText: "", claimTextPurpose: null, notQuiteClaimId: null,
    mode: "home", reviewFilter: "all", reviewSearch: "", pendingClaimIds: new Set(),
  },
  portraitMatching: { enabled: false, resolved: false, consent: false, proposals: [], responding: false, error: null },
  savedPostsById: {},
  discoveryRelatedIds: [],
  feedDisplayOrder: [],
  feedPendingNewIds: [],
  feedRevealAnimateIds: new Set(),
  feedSectionIds: {
    all: { active: [], newThoughts: [], discovery: [] },
    friends: { active: [], newThoughts: [], discovery: [] },
  },
  feedVisibleLimit: 15,
  selectedDiscoveryDirection: null,
  expandedPostIds: new Set(),
  expandedSimilarThoughtIds: new Set(),
  openingSimilarThoughtId: null,
  inlineSimilarThoughtLoading: new Set(),
  friends: [],
  friendSuggestions: [],
  friendSearchResults: [],
  friendSearch: "",
  friendsTab: "friends",
  publicProfile: null,
  communitiesMy: [],
  communitiesPublic: [],
  communitiesInvites: [],
  selectedCommunityId: null,
  selectedCommunity: null,
  selectedCommunityPosts: [],
  selectedCommunityMembers: [],
  selectedCommunityRole: null,
  communitySort: "active",
  communityInviteSearch: "",
  communityPostDraft: { text: "", attribution: "anonymous" as ("anonymous" | "username") },
  communitySubPage: "browse" as import("./types").CommunitySubPage,
  communityDetailTab: "posts" as import("./types").CommunityDetailTab,
  communityOverlay: null as ("create" | "join" | null),
  notes: [],
  activity: [],
  dailyPrompt: {
    prompt: DAILY_PROMPT_FALLBACK[0],
    suggestions: DAILY_PROMPT_FALLBACK.slice(0, 3),
  },
  dailyAnchor: null,
  composer: {
    text: "",
    visibility: "private",
    attribution: "anonymous",
    placeholder: "",
    matchConsent: true,
    isListening: false,
    shareExpanded: false,
    safeReview: null,
  },
  composerResonance: null,
  noteDraft: {
    id: null,
    text: "",
  },
  aiPrefs: {
    notesAiEnabled: false,
    notesAIDisclosureAccepted: false,
    helpfulSimilarThoughtPostIds: [],
    hiddenSimilarThoughtPostIds: [],
  },
  noteEncryption: {
    hasEnvelope: false,
    unlocked: false,
    remembered: false,
    preferredMode: "cross_platform",
    hasLegacyIOSNotes: false,
  },
  noteEncryptionResolved: false,
  passphraseSetupDismissed: false,
  threadInsight: null,
  threadInsightLoading: false,
  noteInsights: {},
  thinkingTimeline: {
    aiReadyEntryCount: 0,
    patterns: [],
    themes: [],
    profile: null,
    source: "empty",
    loading: false,
    error: null,
    selectedPatternId: null,
    isExpanded: false,
  },
  companionContext: {
    memories: [],
    portrait: null,
    loaded: false,
    loading: false,
    error: null,
  },
  companionSession: null,
  companionMomentPage: 0,
  companionHomeIntent: "talk",
  thoughtMatchConfig: {
    thoughtMatchingEnabled: false,
    matchConversationsEnabled: false,
  },
  thoughtMatches: [],
  thoughtMatchConversations: [],
  thoughtMatchLoading: false,
  thoughtMatchError: null,
  thoughtMatchExcerptDraft: null,
  thoughtMatchExcerptError: null,
  selectedMatchConversationId: null,
  thoughtMatchMessages: [],
  thoughtMatchInput: "",
  selectedMatchExcerpt: null,
  userMatches: [],
  echoItems: [],
  joinCodeInput: "",
  threadModal: null,
  threadReplies: [],
  threadLoading: false,
  replyText: "",
  replyAttribution: "username",
  replyingToId: null,
  busy: new Set(),
  confirmModal: null,
};
